module.exports = __webpack_public_path__ + "img/Superrent_App_Mockup_03.056f01fd.png";